import {
    AccountConsent,
    AccountUserConsent,
    CircleConsentConfig,
    CircleConsentTypes,
} from '@calm/evexia-web-sdk';
import {
    getConsentContext,
    getNextConsentType,
} from '@rhg/hooks/use-consent-context';
import { ConsentAcceptance } from '@rhg/hooks/use-consent-context/types';
import {
    getConsentRegistrationStepMiraculouslyWorks,
    RegistrationFlowStep,
} from '@rhg/hooks/use-registration-context/types';

export const CONSUMER_HEALTH_DATA_CONSENT_KEY = 'chdca';

export const findConsentConfig = (
    type: CircleConsentTypes,
    consentConfigs?: CircleConsentConfig[] | null
) => consentConfigs?.find((config) => config.type === type);

// A transition-partner substitution (EVE-14056) needs the destination's own
// next consent step, not the legacy/origin partner's — shared by every path
// that can land a user on a bought-up partner (deep link, manual entry, and
// mid-flow eligibility).
export function getDestinationConsentStep({
    accountConsents,
    accountUserConsents,
    destinationConsentConfigs,
    consentAcceptance,
}: {
    accountConsents: AccountConsent[];
    accountUserConsents: AccountUserConsent[];
    destinationConsentConfigs?: CircleConsentConfig[];
    consentAcceptance?: ConsentAcceptance;
}): RegistrationFlowStep | undefined {
    return getConsentRegistrationStepMiraculouslyWorks(
        getNextConsentType({
            consentRequirements: getConsentContext({
                accountConsents,
                accountUserConsents,
                sponsorConsents: destinationConsentConfigs,
            }),
            consentAcceptance,
        })
    );
}
